// Lodash
import _noop from "lodash/noop";

// Constants
import { PAGE_TITLE } from "../constants";
import { EMPTY_OBJECT } from "../../../../../constants";

const createPageHeaderProps = ({
  actionHandler = _noop,
  actionDisabled = false,
  actionLoading = false,
  paymentId,
} = EMPTY_OBJECT) => {
  return {
    title: `${PAGE_TITLE} - ${paymentId}`,
    actions: [
      {
        title: "Revert Payment",
        handler: actionHandler,
        disabled: actionDisabled,
        loading: actionLoading,
      },
    ],
  };
};

export { createPageHeaderProps };
